import React, { lazy } from 'react'
import { Navigate } from 'react-router-dom'

import { PostBreadcrumbDocument } from 'generated/resources/graphql'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'
import { MetaContext } from 'modules/core/lib/navigation/routes'
import { NavigationRoutesFn } from 'modules/core/lib/react-router'

const EditKudosPage = lazy(() => import('modules/posts/pages/EditKudosPage'))
const EditPostPage = lazy(() => import('modules/posts/pages/EditPostPage'))
const NewKudosPage = lazy(() => import('modules/posts/pages/NewKudosPage'))
const NewPostPage = lazy(() => import('modules/posts/pages/NewPostPage'))
const ShowPostPage = lazy(() => import('modules/posts/pages/ShowPostPage'))

const RootPage = React.lazy(() => import('modules/posts/pages/PostsRootPage'))

const RedirectToDashboard = () => {
  const { navigation } = useNavigation()

  return <Navigate to={navigation.dashboard.fullPath()} replace />
}

export const postDashboardRoutes: NavigationRoutesFn = (navigation) => {
  return [
    {
      path: navigation.dashboard.post.path,
      element: <RootPage />,
      children: [
        {
          index: true,
          element: <RedirectToDashboard />,
        },
        {
          path: navigation.dashboard.post.new.path,
          element: <NewPostPage />,
          handle: {
            meta: () => ({
              title: i18n.t('posts.communities.new_post'),
            }),
          },
        },
        {
          path: navigation.dashboard.post.newEvent.path,
          element: <NewPostPage isEvent />,
          handle: {
            meta: () => ({
              title: i18n.t('posts.communities.new_event_post'),
            }),
          },
        },
        {
          path: navigation.dashboard.post.id.path,
          children: [
            {
              index: true,
              element: <ShowPostPage />,
              handle: {
                meta: retrieveTitle,
              },
            },
            {
              path: navigation.dashboard.post.id.edit.path,
              element: <EditPostPage />,
              handle: {
                meta: retrieveTitle,
              },
            },
          ],
        },
      ],
    },
    {
      path: navigation.dashboard.kudos.path,
      element: <RootPage />,
      children: [
        {
          index: true,
          element: <RedirectToDashboard />,
        },
        {
          path: navigation.dashboard.kudos.new.path,
          element: <NewKudosPage />,
          handle: {
            meta: () => ({
              title: i18n.t('posts.kudos.title'),
            }),
          },
        },
        {
          path: navigation.dashboard.kudos.id.path,
          children: [
            {
              index: true,
              element: <ShowPostPage />,
              handle: {
                meta: retrieveTitle,
              },
            },
            {
              path: navigation.dashboard.kudos.id.edit.path,
              element: <EditKudosPage />,
              handle: {
                meta: retrieveTitle,
              },
            },
          ],
        },
      ],
    },
  ]
}

const retrieveTitle = ({ params, watchQuery }: MetaContext) => {
  return watchQuery({
    query: PostBreadcrumbDocument,
    variables: {
      id: Number(params['id']),
    },
  }).map(({ data }) => {
    const post = data.posts.post
    const title = (post ? post.title : '') ?? ''

    return { title }
  })
}

export default postDashboardRoutes
